module.exports = __webpack_public_path__ + "img/map-marker-anchor.7f0e4b29.png";